// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import LoadingBar from 'react-redux-loading-bar'
import DocumentMeta from 'react-document-meta'

// Internal Dependencies:
import PageData from 'church-theme-library/containers/PageData'
import MainLayout from 'church-theme-library/layouts/MainLayout'
import Page from 'church-theme-library/pages/Page'
import SearchResults from 'church-theme-library/components/Search/SearchResults'

import ErrorBoundary from 'church-theme-library/components/ErrorBoundary/ErrorBoundary'
import CookieConsent from 'church-theme-library/components/CookieConsent/CookieConsent'
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
import HeaderMobile from 'church-theme-library/components/Header/HeaderMobile'
import Header from 'church-theme-library/components/Header/Header'
import Footer from 'church-theme-library/components/Footer/Footer'

class SiteLayout extends React.Component {
	render() {
		const { siteFullName, hasSidebar, menuIsOpen, searchIsOpen, searchResults, isLoading, currentlyViewedPage, selectedArchive, appendedById, location, match, type, cookieConsent, inGdprZone } = this.props
		let className = '/' == location.pathname ? 'site-wrap is-home' : 'site-wrap'
		let showMainInner = true
		let showSearchResults = false
		let documentMeta = false

		// Add page type:
		className += ` is-${type}`

		// Cookie consent:
		if ( inGdprZone && null === cookieConsent ) {
			className += ' with-cookie-consent-bar'
		}

		// Search:
		if ( searchIsOpen ) {
			className += ' with-search-open'
		}

		if ( searchIsOpen && searchResults && searchResults.has_results ) {
			showMainInner = false
			showSearchResults = true
			className += ' with-search-results-open'
		}

		if (
			'posts' == type || 'posts-category' == type ||
			'events' == type || 'events-category' == type ||
			'sermons' == type || 'sermons-category' == type || 'sermon-series' == type ||
			'speakers' == type || 'speakers-category' == type ||
			'bulletins' == type || 'bulletins-category' == type ||
			'galleries' == type || 'galleries-category' == type ||
			'resources' == type || 'resources-category' == type ||
			'ministries' == type
			) {

			className += ' is-archive'
			className += ' is-category'
		}

		// Set head data:
		if ( currentlyViewedPage && currentlyViewedPage.url ) {
			let relativeUrl = currentlyViewedPage.url

			if ( relativeUrl.charAt( 0 ) === '/' ) {
				relativeUrl = relativeUrl.slice( 1 )
			}

			documentMeta = {
				title: `${currentlyViewedPage.title.raw} — ${siteFullName}`,
				description: currentlyViewedPage.description,
				canonical: `${siteData.site_url}/${relativeUrl}`,
				meta: {
					'og:url': `${siteData.site_url}/${relativeUrl}`,
					'og:title': currentlyViewedPage.title.raw,
					'og:description': currentlyViewedPage.description
				}
			}
		} else if ( selectedArchive ) {
			let relativeUrl = selectedArchive.url

			if ( relativeUrl.charAt( 0 ) === '/' ) {
				relativeUrl = relativeUrl.slice( 1 )
			}

			documentMeta = {
				title: `${selectedArchive.title.raw} — ${siteFullName}`,
				description: selectedArchive.description,
				canonical: `${siteData.site_url}/${relativeUrl}`,
				meta: {
					'og:url': `${siteData.site_url}/${relativeUrl}`,
					'og:title': selectedArchive.title.raw,
					'og:description': selectedArchive.description
				}
			}
		} else {
			documentMeta = {
				title: siteFullName,
				description: '',
				canonical: siteData.site_url,
				meta: {
					'og:url': siteData.site_url,
					'og:title': siteFullName,
					'og:description': ''
				}
			}
		}

		if ( 'post' == type && currentlyViewedPage && currentlyViewedPage.page_header_style ) {
			className += ` with-${currentlyViewedPage.page_header_style}`
		}

		return (
			<div className={ className }>
				{ documentMeta &&
					<DocumentMeta { ...documentMeta } />
				}

				<PageData { ...this.props } />
				<CookieConsent />

				<HeaderMobile match={ match } />

				<div className="main-wrap">
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

					<Header match={ match } />

					<section className="main">
						{ isLoading &&
							<LoadingSpinner />
						}

						{ showSearchResults &&
							<ErrorBoundary>
								<SearchResults />
							</ErrorBoundary>
						}

						{ showMainInner &&
							<ErrorBoundary>
								{ this.props.children }
							</ErrorBoundary>
						}
					</section>
				</div>

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		dkePageData: state.page.dkePageData,
		siteFullName: state.site.siteFullName,
		hasSidebar: state.site.hasSidebar,
		menuIsOpen: state.site.menuIsOpen,
		searchIsOpen: state.search.isOpen,
		searchResults: state.search.searchResults,
		isLoading: state.page.isLoading,
		currentlyViewedPage: state.page.currentlyViewedPage,
		selectedArchive: state.page.selectedArchive,
		appendedById: state.page.appendedById,
		inGdprZone: state.site.inGdprZone,
		cookieConsent: state.site.cookieConsent
	}
}

export default connect( mapStateToProps )( SiteLayout )
